import { DestroyRef, Directive, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { DocumentBase } from "@models/documents/document-base";
import { ChangeAuthorisation } from "@models/documents/change-authorisation";
import { Company } from "@models/companies/company";
import { DocumentSigning } from "@models/documents/document-signing";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalFormsService } from "../../../forms/services/modal-forms.service";
import { DocumentSigningsApiService } from "@shared/services/document-signing-api.service";
import { ESignApiService } from "@shared/services/e-sign-api.service";
import { LodgementDeadline } from "@models/documents/lodgement-deadline";

@Directive()
export abstract class SignDocumentsBaseService implements OnInit {
  @Input() documentBase!: DocumentBase;
  @Input() lodgement: LodgementDeadline | undefined;
  @Input() confirmAction$: Subject<boolean> | undefined;
  @Input() confirmSentESignAction$: Subject<boolean> | undefined;
  @Input() confirmPaperSignAction$: Subject<boolean> | undefined;
  @Input() confirmSendEmailAction$: Subject<boolean> | undefined;
  @Input() confirmNotLodgedFormAction$: Subject<boolean> | undefined;

  @Output() refreshSignEntity$ = new Subject<void>();
  @Output() reloadDocument = new EventEmitter<boolean>();
  @Output() nextStep = new EventEmitter<boolean>();

  protected modalService = inject(NgbModal);
  protected toastr = inject(ToastrService);
  protected modalFormsService = inject(ModalFormsService);
  protected destroyRef = inject(DestroyRef);
  protected documentSigningsService = inject(DocumentSigningsApiService);
  protected eSignService = inject(ESignApiService);

  documentSigning: DocumentSigning | null | undefined;
  changeAuthorisation!: ChangeAuthorisation;
  company!: Company;

  ngOnInit(): void {
    this.documentSigning = this.documentBase.documentSigning;
    this.changeAuthorisation = this.documentBase.changeAuthorisation!;
    this.company = this.documentBase.company;
  }

  public abstract disableHeaderBtn(value: boolean): void;

  public abstract showVoidEnvelope(value: boolean): void;

  public abstract showSendEmailBtn(value: boolean): void;

  public abstract showSendPaperBtn(value: boolean): void;

  public abstract sendSignLoading(value: boolean): void;

  public abstract getSendEmailNotification(): string;
}
